import { useSubject } from '@aesop-fables/scrinium';
import { MediaSubject } from '../data/learning/subjects/MediaSubject';
import { MediaData } from '../models/MediaData';

export function useMediaLibrary() {
  const mediaLibrary = useSubject<MediaData[]>(MediaSubject);
  return mediaLibrary;
}
